export default "__VITE_ASSET__BM9$kPHV__"